import { render, staticRenderFns } from "./WalletList.vue?vue&type=template&id=da5a4c4a&scoped=true&"
import script from "./WalletList.vue?vue&type=script&lang=js&"
export * from "./WalletList.vue?vue&type=script&lang=js&"
import style0 from "./WalletList.vue?vue&type=style&index=0&id=da5a4c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5a4c4a",
  null
  
)

export default component.exports